import styles from './gao.module.css';
import { useNavigate } from "react-router-dom";
import HeroBanner from '../../../components/HeroBanner/HeroBanner';
import { useState } from 'react';
function GAO() {
    const [hasImages, setHasImages] = useState(false);
    const navigate = useNavigate();
    return (
        <div>
            <HeroBanner category="gymnasium-am-oelberg" onImagesLoaded={setHasImages} />
            <section className={styles.center} style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }}>
                < h1>Oelberg - Gymnasium</ h1>
                <section>
                    < h2>Betreuungskonzept</ h2>
                    <p>Die Nachmittagsbetreuung am Gymnasium am Ölberg bietet Kindern der 5. und 6. Klassen im Anschluss an die Unterrichtszeit von 13:10 – 15:45 Uhr montags bis freitags (dann jedoch mit dem besonderen Fun Fact Friday) Lernzeitbetreuung und ein offenes Sportangebot (ab 14.40 Uhr).<br /><br />Durch die Nutzung von Klassenräumen mit Schulhofausgang haben die Kinder auch vor dem angeleiteten Sportangebot Möglichkeit zur Bewegung mit Fußball, Basketball, Tischtennis…. Kreative Angebote mit vielfältigem Material und eine große Spieleauswahl machen den Nachmittag für die Kinder abwechslungsreich.<br /><br />Da die Kinder bei ihrem Übergang in die weiterführende Schule in ihrem Hereinwachsen in Selbständigkeit aktiv in der Betreuung unterstützt werden sollen, gibt es keine starren Betreuungszeiten, sondern Betreuungstage, die einzeln „gebucht“ werden können. In Absprache mit den Eltern werden die Zeiten festgelegt und sind im o. g. Zeitraum) variabel.</p>
                </section>
                <section className={styles.team}>
                    < h2>Das Team</ h2>
                    <p>Träger der OGS am GaO ist der TuS 05 Oberpleis e.V.<br />
                        Kontaktmöflichkeiten finden Sie <span tabIndex={0} className={styles.link} onClick={() => navigate("/ogs#kontakt")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {

                                    e.preventDefault(); // Prevent space from scrolling
                                    navigate("/ogs#kontakt")
                                }
                            }}
                        >hier</span>.<br />
                        <br />Unser Team besteht aus:</p>

                    <table className={styles.table}>
                        <tr className={styles.trow}>
                            <td className={styles.firstTableItem}>Helena Weber</td>
                            <td>(Betreuung),</td>
                        </tr>
                        <tr className={styles.trow}>
                            <td className={styles.firstTableItem}>Karim El Gharbi</td>
                            <td>(Betreuung),</td>
                        </tr>
                        <tr className={styles.trow}>
                            <td className={styles.firstTableItem}>Selim El Gharbi</td>
                            <td>(Betreuung und Sportangebot, FSJler und Trainer TuS 05),</td>
                        </tr>
                        <tr className={styles.trow}>
                            <td className={styles.firstTableItem}>Louis Coenen</td>
                            <td>(Betreuung und Sportangebot, FSJler und Trainer TuS 05),</td>
                        </tr>
                        <tr className={styles.trow}>
                            <td className={styles.firstTableItem}>Can Thelen</td>
                            <td>(Betreuung und Sportangebot, FSJler und Trainer TuS 05) und</td>
                        </tr>
                        <tr className={styles.trow}>
                            <td className={styles.firstTableItem}>Irina Wistoff</td>
                            <td>(Leitung und Betreuung).</td>
                        </tr>
                    </table>
                </section>

                <section>
                    < h2>Anmeldung / Elternbeiträge</ h2>
                    <p>Alles wichtige bzgl. der Anmeldung sowie den Kosten finden Sie hier: <span tabIndex={0} className={styles.link} onClick={() => navigate("/ogs/anmeldung-und-elternbeitraege#anmeldung")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {

                                e.preventDefault(); // Prevent space from scrolling
                                navigate("/ogs/anmeldung-und-elternbeitraege#anmeldung")
                            }
                        }}
                    >Anmeldung / Elternbeiträge</span></p>
                </section>


                <section>
                    < h2>Fun Fact Friday - Der Entdeckertag am GaO</ h2>
                    <p>Das Motto des Fun Fact Friday ist: Mit Spaß und Bewegung Ungewöhnliches entdecken und Neues lernen. Daher entdecken die Kinder gemeinsam mit Museumspädagogin Irina Wistoff besondere Orte und Menschen in der Umgebung. Ein paar Beispiele aus vergangenen Freitagen:</p>
                    <ul>
                        <li>Sportstunde mit den Telekom Baskets</li>
                        <li>Besuche im Haus der Geschichte, Haus Schlesien, der Bundeskunsthalle…</li>
                        <li>Besuch eines Meeresbiologen</li>
                        <li>Kunstprojekte (Graffiti, Stencils, Fotografische Experimente, Bookart, Roomerangs…)</li>
                        <li>Vorlesung an der Hochschule Bonn-Rhein-Sieg</li>
                        <li>Speerwerfen mit der SSG</li>
                        <li>Besuch des Bürgermeisters</li>
                    </ul>
                </section>
            </section>
        </div>
    )
}

export default GAO;